import { defaultDarkTheme, defaultTheme } from "react-admin";

export const darkTheme = {
  ...defaultDarkTheme,
  components: {
    ...defaultDarkTheme.components,
    MuiLink: {
      defaultProps: {
        ...defaultDarkTheme.components?.MuiLink?.defaultProps,
        underline: "none",
      },
    },
    MuiTextField: {
      defaultProps: {
        ...defaultDarkTheme.components?.MuiTextField?.defaultProps,
        variant: "filled",
      },
    },
  },
  palette: {
    ...defaultDarkTheme.palette,
    primary: {
      main: "#FFECB3",
    },
    secondary: {
      main: "#121212",
    },
    background: {
      default: "#121212",
    },
    text: {
      primary: "rgba(255,255,255,.87)",
      secondary: "rgba(255,255,255,.6)",
      disabled: "rgba(255,255,255,.38)",
    },
  },
};

export const theme = {
  ...defaultTheme,
  palette: {
    ...defaultTheme.palette,
    primary: {
      main: "#C27E00",
      light: "#C5CAE9",
      dark: "#303F9F",
    },
    background: {
      default: "#F9F9F9",
    },
    text: {
      primary: "#0C0C0C",
      secondary: "rgba(12,12,12,0.6)",
      disabled: "rgba(12,12,12,0.38)",
    },
    secondary: {
      main: "#FFC123",
      light: "#FFECB3",
      dark: "#FFA000",
    },
    error: {
      main: "#d32f2f",
    },
    warning: {
      main: "#ed6c02",
    },
    info: {
      main: "#0288d1",
    },
  },
  components: {
    ...defaultTheme.components,
    MuiLink: {
      defaultProps: {
        ...defaultTheme.components?.MuiLink?.defaultProps,
        underline: "none",
      },
    },
    MuiTextField: {
      defaultProps: {
        ...defaultTheme.components?.MuiTextField?.defaultProps,
        variant: "filled",
      },
    },
  },
};
